export const facData = [
    {name: "groupName", mandatory: true, diapName: "Group Name", type: "select"},
    {name: "factoryCode", mandatory: true, diapName: "Factory Code", type: "text"},
    {name: "factoryName", mandatory: true, diapName: "Factory Name", type: "text"},
    {name: "location", diapName: "Location", type: "text"},
    {name: "discription", diapName: "Discription", type: "textarea"},
    {name: "active", diapName: "Active", type: "checkbox"},
];

